// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28tdr","productName":"Table_productName__2JBzJ"};